import {
  inject,
  Injector,
  runInInjectionContext,
  untracked,
} from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { initialState } from './loghi.state';
import { defaultIfEmpty, firstValueFrom } from 'rxjs';
import { StorageService } from '../../_services/storage.service';

const pendingRequests = new Map<string, Promise<string | null>>();

export const LoghiStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, injector = inject(Injector)) => ({
    getLogo: (id: string) =>
      runInInjectionContext(injector, async () => {
        if (!id) return null;

        const _storage = inject(StorageService);
        const currentLoghi = untracked(() => store.loghi?.()) ?? {};

        // Se già presente nello stato, ritorna subito
        if (currentLoghi[id] !== undefined) {
          return currentLoghi[id];
        }

        // Se c'è già una richiesta pendente per questo id, ritorna la stessa promise
        if (pendingRequests.has(id)) {
          return pendingRequests.get(id);
        }

        // Altrimenti, crea una nuova richiesta e salvala tra i pending
        const fetchPromise = firstValueFrom(
          _storage.getFileUrl(id).pipe(defaultIfEmpty(null)),
        ).then((url) => {
          if (url) {
            const updatedLoghi = {
              ...(untracked(() => store.loghi?.()) ?? {}),
              [id]: url,
            };

            patchState(store, {
              loghi: updatedLoghi,
            });
          }
          pendingRequests.delete(id); // Rimuovi dopo completamento
          return url;
        });

        pendingRequests.set(id, fetchPromise);
        return fetchPromise;
      }),
  })),
);
